import CourseDetailModal from './CourseDetailModal';
export default CourseDetailModal;
